export const adminsPath = {
  admins: "admins", // массив всех админов содержит админов, оперторов(визовиков), супервизовиков.
};
